var map = {
	"./articles.ar.json": [
		7050,
		7050
	],
	"./articles.de.json": [
		8392,
		8392
	],
	"./articles.en.json": [
		3953
	],
	"./articles.es.json": [
		4068,
		4068
	],
	"./articles.fr.json": [
		6666,
		6666
	],
	"./articles.ja.json": [
		3166,
		3166
	],
	"./articles.ko.json": [
		5067,
		5067
	],
	"./articles.pt.json": [
		9207,
		9207
	],
	"./articles.ru.json": [
		4920,
		4920
	],
	"./articles.zh.json": [
		8769,
		8769
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9290;
module.exports = webpackAsyncContext;